import React from 'react';
import styles from './itemsList.module.css';

import {connect} from 'react-redux';
import {
    changeCreateItemAuctionId,
    changeCreateItemClassificationId,
    changeCreateItemUnitValueCurrency,
    changeCreateItemUnitValueAmount,
    changeCreateItemUnitValueTax,
    changeCreateItemDescription,
    changeAdditionalClassificationIds,
    changeCreateItemQuantity,
    changeCreateItemIds,
    changeLoader,
    getMyAuction,
    changeCreateItemLocationLatitude,
    changeCreateItemLocationLongitude,
    changeCreateItemLocationElevation,
    changeCreateItemAddress,
    changeCreateItemDgfJointPropertyComplexPropsId,
    changeCreateItemDgfJointPropertyComplexPropsQuantityAndNomenclature,
    changeCreateItemDgfJointPropertyComplexPropsWorkplacesQuantity,
    changeCreateItemDgfJointPropertyComplexPropsBuildingsInformation,
    changeCreateItemDgfJointPropertyComplexPropsLandPlotInformation,
    changeCreateItemDgfJointPropertyComplexPropsMainObligations,
    changeCreateItemDgfLandPropsId,
    changeCreateItemDgfLandPropsLandArea,
    changeCreateItemDgfLandPropsCadastralNumber,
    changeCreateItemDgfLandPropsOwnershipType,
    changeCreateItemDgfLandPropsEncumbrances,
    changeCreateItemDgfLandPropsJointOwnership,
    changeCreateItemDgfLandPropsUtilitiesAvailability,
    changeCreateItemDgfLandPropsIntendedUse,
    changeCreateItemDgfVehiclePropsId,
    changeCreateItemDgfVehiclePropsBrand,
    changeCreateItemDgfVehiclePropsModel,
    changeCreateItemDgfVehiclePropsProductionYear,
    changeCreateItemDgfVehiclePropsEngineCapacity,
    changeCreateItemDgfVehiclePropsFuelType,
    changeCreateItemDgfVehiclePropsTransmission,
    changeCreateItemDgfVehiclePropsColor,
    changeCreateItemDgfVehiclePropsKilometrage,
    changeCreateItemDgfVehiclePropsIdentificationNumber,
    changeCreateItemDgfVehiclePropsConfiguration,
    changeCreateItemDgfVehiclePropsCondition,
    changeCreateItemDgfVehiclePropsDamagePresence,
    changeCreateItemDgfVehiclePropsDamagedDescription,
} from '../../../../../redux/actions.js';
import {auctionsGetMy,
    auctionsGetMyId,
    changeAuctionsItemsSwitchWindow,
    changeAuctionsSwitchWindow,
    
    auctionsGetClassificationsByGenerationType,
    changeTimberSortment,
    changeTimberSpecies,
    changeTimberClass,
    changeTimberDiameter,
    changeTimberLength,
    changeTimberStorage,
    changeTimberProductionYear,
    changeTimberProductionQuarter,
    changeCreateItemUnitCode,
    changeCreateItemGenerationType,
    auctionsGetClassificationsByTypeDGFAdd,
    seDgfMask,
} from '../../../../../redux/actions/auctions/auctions.js';

import 'date-fns';

import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import IconButton from '@material-ui/core/IconButton';

const ItemsList = ( props ) => {

    let tmpArr = null;
    //if(tmp !== null){
    if(props.auctionsMy !== null){
        //if(tmp.length > 0){
            //tmpArr = tmp[0].items.map(
            tmpArr = props.auctionsMy.items.map(
                (i) => {
                    return (
                        <div key={i.id} className={styles.auctionsLine}>
                            <div className={styles.auctionsLineElem}>
                                <div className={styles.itemsId}>Id лота: {i.id}</div>
                                <div>Опис лота: {i.description}</div>
                            </div>
                            <div className={styles.auctionsLineElem}>
                                <div
                                    onClick={
                                        () => {
                                            props.changeAuctionsItemsSwitchWindow(2);
                                            
                                            props.changeCreateItemAuctionId(props.auctionsMy.id)
                                            props.changeCreateItemIds(i.id)
                                            props.changeCreateItemClassificationId(i.classification.id)
                                            props.changeCreateItemDescription(i.description)
                                            props.changeCreateItemAuctionId(i.unitCode)
                                            props.changeCreateItemQuantity(i.quantity)

                                            props.changeCreateItemLocationLatitude(i.location.latitude)
                                            props.changeCreateItemLocationLongitude(i.location.longitude)
                                            props.changeCreateItemLocationElevation(i.location.elevation)

                                            if(i.jointPropertyComplexProps !== null){
                                                props.changeCreateItemDgfJointPropertyComplexPropsId(i.jointPropertyComplexProps.id)
                                                props.changeCreateItemDgfJointPropertyComplexPropsQuantityAndNomenclature(i.jointPropertyComplexProps.quantityAndNomenclature)
                                                props.changeCreateItemDgfJointPropertyComplexPropsWorkplacesQuantity(i.jointPropertyComplexProps.workplacesQuantity)
                                                props.changeCreateItemDgfJointPropertyComplexPropsBuildingsInformation(i.jointPropertyComplexProps.buildingsInformation)
                                                props.changeCreateItemDgfJointPropertyComplexPropsLandPlotInformation(i.jointPropertyComplexProps.landPlotInformation)
                                                props.changeCreateItemDgfJointPropertyComplexPropsMainObligations(i.jointPropertyComplexProps.mainObligations)
                                            }
                                            if(i.landProps !== null){
                                                props.changeCreateItemDgfLandPropsId(i.landProps.id)
                                                props.changeCreateItemDgfLandPropsLandArea(i.landProps.landArea)
                                                props.changeCreateItemDgfLandPropsCadastralNumber(i.landProps.cadastralNumber)
                                                props.changeCreateItemDgfLandPropsOwnershipType(i.landProps.ownershipType)
                                                props.changeCreateItemDgfLandPropsEncumbrances(i.landProps.encumbrances)
                                                props.changeCreateItemDgfLandPropsJointOwnership(i.landProps.jointOwnership)
                                                props.changeCreateItemDgfLandPropsUtilitiesAvailability(i.landProps.utilitiesAvailability)
                                                props.changeCreateItemDgfLandPropsIntendedUse(i.landProps.intendedUse)
                                            }
                                            if(i.vehicleProps !== null){
                                                props.changeCreateItemDgfVehiclePropsId(i.vehicleProps.id)
                                                props.changeCreateItemDgfVehiclePropsBrand(i.vehicleProps.brand)
                                                props.changeCreateItemDgfVehiclePropsModel(i.vehicleProps.model)
                                                props.changeCreateItemDgfVehiclePropsProductionYear(i.vehicleProps.productionYear)
                                                props.changeCreateItemDgfVehiclePropsEngineCapacity(i.vehicleProps.engineCapacity)
                                                props.changeCreateItemDgfVehiclePropsFuelType(String(i.vehicleProps.fuelType))
                                                props.changeCreateItemDgfVehiclePropsTransmission(String(i.vehicleProps.transmission))
                                                props.changeCreateItemDgfVehiclePropsColor(i.vehicleProps.color)
                                                props.changeCreateItemDgfVehiclePropsKilometrage(i.vehicleProps.kilometrage)
                                                props.changeCreateItemDgfVehiclePropsIdentificationNumber(i.vehicleProps.identificationNumber)
                                                props.changeCreateItemDgfVehiclePropsConfiguration(i.vehicleProps.configuration)
                                                props.changeCreateItemDgfVehiclePropsCondition(i.vehicleProps.condition)
                                                props.changeCreateItemDgfVehiclePropsDamagePresence(String(i.vehicleProps.damagePresence))
                                                props.changeCreateItemDgfVehiclePropsDamagedDescription(i.vehicleProps.damagedDescription)
                                            }
                                            if(i.realEstateProps !== null){}

                                            props.seDgfMask(i.classification.classificationId)
                                            let header5 = {
                                                'Authorization': props.token.access_token,
                                                'Content-Type': 'application/json'
                                            }
                                            let data5 = {
                                                domen: process.env.REACT_APP_END_POINT_BD,
                                                version: 'v1',
                                                local: props.langFlag,
                                                params: '?limit=100'
                                            }
                                            props.auctionsGetClassificationsByTypeDGFAdd(data5, header5, i.classification.classificationId)

                                            if(i.additionalClassifications.length > 0){
                                                props.changeCreateItemGenerationType(i.additionalClassifications[0].id)
                                            }else{
                                                props.changeCreateItemGenerationType('')
                                            }
                                            props.changeCreateItemUnitCode(i.unit.code)
                                            props.changeCreateItemAddress(i.address.id)

                                            let data = {
                                                domen: process.env.REACT_APP_END_POINT_BD,
                                                version: 'v1',
                                                local: props.langFlag,
                                                params: '?limit=20'
                                            }
                                            let header = {
                                                'Authorization': props.token.access_token,
                                                'Content-Type': 'application/json'
                                            }
                                            props.auctionsGetClassificationsByGenerationType(data, header)
                                        }
                                    }
                                >
                                    <IconButton aria-label="edit">
                                        <EditIcon />
                                    </IconButton>
                                </div>
                                <div
                                    onClick={
                                        () => {
                                            props.changeLoader(true)
                                            deleteItem(props, props.auctionsMy, i.id)
                                            //props.changeAuctionsSwitchWindow(0)
                                        }
                                    }
                                >
                                    <IconButton aria-label="delete">
                                        <DeleteIcon />
                                    </IconButton>
                                </div>
                            </div>
                        </div>
                    )
                }
            )
        //}
    }
    return tmpArr
}

async function  deleteItem(props, aucId, itemId){
    
    const endPoint = `${process.env.REACT_APP_END_POINT_BD}/api/v1/uk/auction/${aucId}/item/${itemId}`;
    const response1 = await fetch(endPoint, {
        method: "delete",
        headers: {
            'Authorization': props.token.access_token,
            'Content-Type': 'application/json'
        }
    }).catch(console.error)
    if(response1 === undefined || response1 === 'undefined'){
    }else{
        let header = {
            'Authorization': props.token.access_token,
            'Content-Type': 'application/json'
        }
        const endPoint2 = `${process.env.REACT_APP_END_POINT_BD}/api/v1/uk/auction/${props.auctionsMy.id}`;
        props.changeLoader(true)
        const response2 = await fetch(endPoint2, {
                method: "GET",
                headers: header
        }).catch(console.error)
        if(response2 === undefined || response2 === 'undefined'){
        }else{
            props.changeAuctionsItemsSwitchWindow(0);
            const json2 = await response2.json()
            if(json2.hasOwnProperty('message') === true){
                props.changeLoader(false)
            }else{
                props.getMyAuction(json2)
                props.changeLoader(false)
            }
        }
    }
}

const mapStateToProps = state => {
    return {
        token: state.start.token,
        auctions: state.start.auctionsGet,
        langFlag: state.start.langFlag,
        createAuctionTab: state.start.createAuctionTab,
        createAuction: state.start.createAuction,
        createItems: state.start.createItems,
        auctionsMy: state.start.auctionsMy,
        auctionsItemsSwitchWindow: state.start.auctionsItemsSwitchWindow,
        classificationsGets: state.start.classificationsGet,
        unitsGet: state.start.unitsGet,
        userProfiles: state.start.userProfiles,
        classificationsTimber: state.start.classificationsTimber,
        classificationsEnergy: state.start.classificationsEnergy,
        auctionsList: state.start.auctionsGetMy
    }
}

const mapDispatchToProps = {
    changeCreateItemAuctionId,
    changeCreateItemClassificationId,
    changeCreateItemUnitValueCurrency,
    changeCreateItemUnitValueAmount,
    changeCreateItemUnitValueTax,
    changeCreateItemDescription,
    changeAuctionsItemsSwitchWindow,
    auctionsGetMy,
    auctionsGetMyId,
    changeAuctionsSwitchWindow,
    changeAdditionalClassificationIds,
    changeCreateItemQuantity,
    changeCreateItemIds,
    //auctionsGetClassificationsByType,
    
    auctionsGetClassificationsByGenerationType,
    //auctionsGetClassificationsByTimberSortment,
    //auctionsGetClassificationsByTimberSpecies,
    //auctionsGetClassificationsByTimberClass,
    //auctionsGetClassificationsByTimberDiameter,
    //auctionsGetClassificationsByTimberLength,
    //auctionsGetClassificationsByTimberStorage,
    //auctionsGetClassificationsByTimberProductionYear,
    //auctionsGetClassificationsByTimberProductionQuarter,
    changeTimberSortment,
    changeTimberSpecies,
    changeTimberClass,
    changeTimberDiameter,
    changeTimberLength,
    changeTimberStorage,
    changeTimberProductionYear,
    changeTimberProductionQuarter,
    changeCreateItemUnitCode,
    changeCreateItemGenerationType,
    changeLoader,
    getMyAuction,
    changeCreateItemLocationLatitude,
    changeCreateItemLocationLongitude,
    changeCreateItemLocationElevation,
    auctionsGetClassificationsByTypeDGFAdd,
    seDgfMask,
    changeCreateItemAddress,
    changeCreateItemDgfJointPropertyComplexPropsId,
    changeCreateItemDgfJointPropertyComplexPropsQuantityAndNomenclature,
    changeCreateItemDgfJointPropertyComplexPropsWorkplacesQuantity,
    changeCreateItemDgfJointPropertyComplexPropsBuildingsInformation,
    changeCreateItemDgfJointPropertyComplexPropsLandPlotInformation,
    changeCreateItemDgfJointPropertyComplexPropsMainObligations,
    changeCreateItemDgfLandPropsId,
    changeCreateItemDgfLandPropsLandArea,
    changeCreateItemDgfLandPropsCadastralNumber,
    changeCreateItemDgfLandPropsOwnershipType,
    changeCreateItemDgfLandPropsEncumbrances,
    changeCreateItemDgfLandPropsJointOwnership,
    changeCreateItemDgfLandPropsUtilitiesAvailability,
    changeCreateItemDgfLandPropsIntendedUse,
    changeCreateItemDgfVehiclePropsId,
    changeCreateItemDgfVehiclePropsBrand,
    changeCreateItemDgfVehiclePropsModel,
    changeCreateItemDgfVehiclePropsProductionYear,
    changeCreateItemDgfVehiclePropsEngineCapacity,
    changeCreateItemDgfVehiclePropsFuelType,
    changeCreateItemDgfVehiclePropsTransmission,
    changeCreateItemDgfVehiclePropsColor,
    changeCreateItemDgfVehiclePropsKilometrage,
    changeCreateItemDgfVehiclePropsIdentificationNumber,
    changeCreateItemDgfVehiclePropsConfiguration,
    changeCreateItemDgfVehiclePropsCondition,
    changeCreateItemDgfVehiclePropsDamagePresence,
    changeCreateItemDgfVehiclePropsDamagedDescription,
}

export default connect(mapStateToProps, mapDispatchToProps)(ItemsList)
